import { render, staticRenderFns } from "./OwnerFormList.vue?vue&type=template&id=630e90d1&"
import script from "./OwnerFormList.vue?vue&type=script&lang=ts&"
export * from "./OwnerFormList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports